import axios from 'axios'
import NProgress from 'nprogress'
import store from '../store/store'
import router from '../router'
import moment from 'moment'
import { baseUrls } from './../const'

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})
apiClient.interceptors.request.use(
  config => {
    let url = config.url.split('?')[0]
    for (let key in baseUrls) {
      url = url.replace(baseUrls[key], '')
    }
    let user = JSON.parse(localStorage.getItem('user'))
    let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'))

    if (store.state.user.is_internet_error) {
      return Promise.reject(false)
    }
    // If the token expiration time is less than 2 minutes and the network is good, refresh the token
    if (user && tokenInfo) {
      let expireDiff = moment
        .unix(tokenInfo.expires_on)
        .diff(moment(), 'minutes')
      if (
        expireDiff < 5 &&
        !store.state.user.token_refreshing &&
        !store.state.user.is_internet_error &&
        url !== store.state.user.logout_request
      ) {
        store.dispatch('user/refreshToken').catch(() => {
          store.dispatch('user/logout')
        })
      }
    }

    // Add a token to the request header, except for the no token request
    if (store.state.user.no_token_request.join('').indexOf(url) < 0) {
      let token = tokenInfo.access_token
      token = 'Bearer ' + token
      if (!token) {
        router.push('/sign-in')
        var error = new Error('token_not_provided')
        return Promise.reject(error)
      } else {
        config.headers.Authorization = token
      }
    }

    if (store.state.user.no_loading_request.join('').indexOf(url) < 0) {
      NProgress.start()
    }
    return config
  },
  error => {
    return error
  }
)

apiClient.interceptors.response.use(
  response => {
    var url = response.config.url.split('?')[0]
    for (let key in baseUrls) {
      url = url.replace(baseUrls[key], '')
    }
    if (store.state.user.no_loading_request.join('').indexOf(url) < 0) {
      NProgress.done()
    }
    return response
  },
  error => {
    let response = error.response
    var url = response.config.url.split('?')
    if (
      response &&
      response.status === 401 &&
      store.state.user.no_token_request.join('').indexOf(url) < 0
    ) {
      store.dispatch('user/logout')
    }
    NProgress.done()
    return Promise.reject(error)
  }
)

export default apiClient
